import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@beresta/ui/tokens.css";
import "./app.css";
import { App } from "./App.js";
import { DbProvider } from "./db/provider.js";
import { applyTextStep } from "./platform/appearance.js";

// Розмір тексту записів — до першого кадру, щоб текст не стрибав.
applyTextStep();
// Chrome віддає `beforeinstallprompt` один раз і рано — ловимо до React,
// а читає лінивий `platform/install.ts`.
globalThis.addEventListener("beforeinstallprompt", (event) => {
  event.preventDefault();
  (globalThis as unknown as { __installEvent?: Event }).__installEvent = event;
});
const root = document.getElementById("root");
if (!root) throw new Error("немає #root");

function start(host: HTMLElement) {
  createRoot(host).render(
    <StrictMode>
      <DbProvider>
        <App />
      </DbProvider>
    </StrictMode>,
  );
}

// Повернення від Google — теж до першого кадру: токен має зникнути з
// адреси раніше, ніж роутер її прочитає чи браузер покладе в історію.
// Модуль вантажиться лише на цій адресі: у звичайному запуску він не
// потрібен, а холодний старт рахує кожен байт (ADR-0030).
if (location.pathname === "/share") {
  // «Поділитися» з іншого застосунку — так само до першого кадру: адреса
  // з поділеним текстом не має лягти в історію чи дійти до роутера.
  void import("./platform/share.js")
    .then((m) => m.captureShare())
    .finally(() => start(root));
} else if (location.pathname === "/google") {
  void import("./platform/googleReturn.js")
    .then((m) => m.captureGoogleReturn())
    .finally(() => start(root));
} else {
  start(root);
}
